import { Freight } from '@interfaces/freight';
import { getCall } from '@services/rest-service';

// Retrieves all the freight from cosmos
export const getFreight = (): Promise<Freight[]> => {
  return getCall<Freight[]>('freight');
};